// @ts-nocheck
import loadProductPricingAndInventory from "@insite/client-framework/Store/Pages/ProductDetails/Handlers/LoadProductPricingAndInventory";
import {
    chain,
    DispatchUpdateVariantSelection,
    SelectVariantProduct as BaseSelectVariantProduct,
    SetVariantSelection as BaseSetVariantSelection,
} from "@insite/client-framework/Store/Pages/ProductDetails/Handlers/UpdateVariantSelection";
import {
    getProductState,
    getVariantChildrenDataView,
} from "@store/Modules/client-framework/src/Store/Data/Products/ProductsSelectors";
import { addToChainBefore, createChainHandler, replaceInChain } from "@toolkit/Modules/client-framework/HandlerCreator";

export interface VariantSelection {
    variantTraitId: string;
    traitValueId: string;
}

export const SetVariantSelection = createChainHandler("SetVariantSelection", chain, props => {
    /* Store Custom Code - Start */
    const selectionParameter = (props.parameter as any).selection as VariantSelection[];

    if (!selectionParameter) {
        return;
    }

    selectionParameter.forEach(x => {
        props.variantSelection[x.variantTraitId] = x.traitValueId;
    });
    /* Store Custom Code - End */
});

replaceInChain(chain, BaseSetVariantSelection, SetVariantSelection);

export const SelectVariantProduct = createChainHandler("SelectVariantProduct", chain, props => {
    props.selectedProductId = props.parameter.productId;

    if (!props.variantSelectionCompleted) {
        return;
    }

    const variantChildren = getVariantChildrenDataView(props.getState(), props.parameter.productId).value!; // Store Custom Code

    for (const variantChild of variantChildren) {
        if (!variantChild.childTraitValues || variantChild.childTraitValues.length === 0) {
            continue;
        }

        let matches = true;
        for (const childTraitValue of variantChild.childTraitValues) {
            if (props.variantSelection[childTraitValue.styleTraitId] !== childTraitValue.id) {
                matches = false;
                break;
            }
        }

        if (matches) {
            props.selectedProductId = variantChild.id;
            return;
        }
    }

    // if we are here, it means that the selected product is not available for some reasons (discontinued)
    // in this case we need to reset variant selection
    props.variantSelection = {};
    const product = getProductState(props.getState(), props.parameter.productId).value;
    product?.variantTraits?.forEach(variantTrait => {
        props.variantSelection[variantTrait.id] = "";
    });
    props.variantSelectionCompleted = false;
});

replaceInChain(chain, BaseSelectVariantProduct, SelectVariantProduct);

export const LoadRealTimePricingAndInventory = createChainHandler("LoadRealTimePricingAndInventory", chain, props => {
    const { dispatch, productInfo, selectedProductId: productId, variantSelectionCompleted } = props;

    if (!productInfo || !productId || !variantSelectionCompleted) {
        return;
    }

    dispatch(
        loadProductPricingAndInventory({
            product: getProductState(props.getState(), productId).value,
            productInfosById: { [productId]: productInfo },
        }),
    );
});

addToChainBefore(chain, DispatchUpdateVariantSelection, LoadRealTimePricingAndInventory);
